/**
 * @file DashboardDetail.jsx
 * @author Daniel Aguirre
 * @description Dashboard Detail Management View Page
 */

// Dependencies
import { useTranslation } from 'react-i18next';
import AppCardLayout from 'components/AppCardLayout';
import React from 'react';
import ManagementViewGenerator from 'components/ManagementViewGenerator';

// Hooks
import useSearch from '@nephro/hook/useSearch';

// Helpers
import { sortString } from '@nephro/commons/helpers/utils';
import TableFilter from 'components/TableFilter';
import dashboardDetailMock from './dashboardDetailMock';

function DashboardDetail() {
  const { t: translate } = useTranslation();
  const [rowData, setRowData] = React.useState([]);
  const { setSearchTerm, filteredRows } = useSearch(rowData);

  const columns = [
    {
      title: translate('dashboardDet.risk'),
      dataIndex: 'badgeRisk',
      sorter: sortString('badgeRisk')
    },
    {
      title: translate('dashboardDet.month'),
      dataIndex: 'month',
      sorter: sortString('month')
    },
    {
      title: translate('dashboardDet.names'),
      dataIndex: 'names',
      sorter: sortString('names')
    },
    {
      title: translate('dashboardDet.lastNames'),
      dataIndex: 'lastNames',
      sorter: sortString('lastNames')
    },
    {
      title: translate('dashboardDet.id'),
      dataIndex: 'id',
      sorter: sortString('id')
    },
    {
      title: translate('dashboardDet.age'),
      dataIndex: 'age',
      sorter: sortString('age')
    },
    {
      title: translate('dashboardDet.insuranceCarrier'),
      dataIndex: 'insuranceCarrier',
      sorter: sortString('insuranceCarrier')
    },
    {
      title: translate('dashboardDet.sgateTFG'),
      dataIndex: 'sgateTFG',
      sorter: sortString('sgateTFG')
    },
    {
      title: translate('dashboardDet.TFG'),
      dataIndex: 'TFG',
      sorter: sortString('TFG')
    },
    {
      title: translate('dashboardDet.kidneyUnit'),
      dataIndex: 'kidneyUnit',
      sorder: sortString('kidneyUnit')
    },
    {
      title: translate('dashboardDet.TFG2009'),
      dataIndex: 'TFG2009',
      sorder: sortString('TFG2009')
    },
    {
      title: translate('dashboardDet.stageTFG2009'),
      dataIndex: 'stageTFG2009',
      sorder: sortString('stageTFG2009')
    },
    {
      title: translate('dashboardDet.modality'),
      dataIndex: 'modality',
      sorder: sortString('modality')
    },
    {
      title: translate('dashboardDet.therapy'),
      dataIndex: 'therapy',
      sorder: sortString('therapy')
    }
  ];

  const setRiskBadge = () => {
    let badgeRisk = '';
    const detailWithBadge = dashboardDetailMock.map((detail) => {
      switch (detail.risk) {
        case 'Alto':
          badgeRisk = (
            <div className="text-center font-bold w-max px-4 text-white rounded-full bg-error">
              Alto
            </div>
          );
          break;
        case 'Medio':
          badgeRisk = (
            <div className="text-center font-bold w-max px-4 text-white rounded-full bg-brandOrange">
              Medio
            </div>
          );
          break;
        default:
          break;
      }
      return { ...detail, badgeRisk };
    });
    return detailWithBadge;
  };

  React.useEffect(() => {
    setRowData(setRiskBadge());
  }, [setRowData]);

  const menuMonth = [
    { key: 0, value: '' },
    { key: 1, value: 'Agosto' },
    { key: 2, value: 'Julio' }
  ];

  const menuRisk = [
    { key: 0, value: '' },
    { key: 1, value: 'Alto' },
    { key: 2, value: 'Medio' }
  ];

  const rightOptions = [
    <label className="w-max" key={0}>
      {translate('dashboardDet.filterBy')}:
    </label>,
    <TableFilter
      key={1}
      label={translate('dashboardDet.month')}
      menuItems={menuMonth}
      onSelectItem={(_, value) => setSearchTerm(value)}
    />,
    <TableFilter
      key={2}
      label={translate('dashboardDet.risk')}
      menuItems={menuRisk}
      onSelectItem={(_, value) => setSearchTerm(value)}
    />
  ];

  return (
    <AppCardLayout>
      <div>
        <ManagementViewGenerator
          rightOptions={rightOptions}
          columns={columns}
          data={filteredRows}
          filter={false}
        />
      </div>
    </AppCardLayout>
  );
}

export default DashboardDetail;
